const institutions = {
  fei: {
    href: 'https://www.fei.tuke.sk/en',
    src: '/brand/fei-monochrome.svg',
    name: 'Faculty of Electrical Engineering and Informatics, Technical University of Košice',
    width: 1000,
    height: 310,
    classes: 'bg-[#ffffff] dark:bg-black',
    imageClasses: 'scale-[1.15] dark:invert',
  },
  tuke: {
    href: 'https://www.tuke.sk/en',
    src: '/brand/tuke-monochrome.svg',
    name: 'Technical University of Košice',
    width: 1000,
    height: 310,
    classes: 'bg-[#ffffff] dark:bg-black',
    imageClasses: 'scale-[1.15] dark:invert',
  },
  minedu: {
    href: 'https://www.minedu.sk/',
    src: '/brand/minedu.svg',
    darkSrc: '/brand/minedu-dark.svg',
    name: 'Ministry of Education, Research, Development and Youth of the Slovak Republic',
    width: 539,
    height: 255,
    classes: 'bg-[#ffffff] dark:bg-black',
    imageClasses: 'scale-150',
  },
};

export function InstitutionLogo({ institution, className = '' }: {
  institution: keyof typeof institutions;
  className?: string;
}) {
  const logo = institutions[institution];

  return (
    <a
      href={logo.href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex h-24 w-60 max-w-full shrink-0 items-center justify-center rounded-lg p-3 ring-1 ring-gray-200 transition-shadow hover:ring-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-500 dark:ring-gray-700 ${logo.classes} ${className}`}
    >
      <span className="flex h-full w-full items-center justify-center overflow-hidden">
        <img src={logo.src} alt={logo.name} width={logo.width} height={logo.height} loading="lazy" className={`h-full w-full object-contain ${'darkSrc' in logo ? 'dark:hidden' : ''} ${logo.imageClasses}`} />
        {'darkSrc' in logo && <img src={logo.darkSrc} alt={logo.name} width={logo.width} height={logo.height} loading="lazy" className={`hidden h-full w-full object-contain dark:block ${logo.imageClasses}`} />}
      </span>
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}
